// Styles
import IframeContainer from "../IframeContainer.styles";
import PowerBIDashboard from "../../../components/Common/PowerBIDashboard";
import React from "react";

type Props = {};

export default function SustainabilityDashboard({}: Props) {
    return (
        <IframeContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId="e70509bb-111d-4ab1-8b7a-a5e49b1b0195"
                    workspaceId="0ab7398c-fff1-4373-b543-e7d6d23657cd"
                ></PowerBIDashboard>
            </div>
        </IframeContainer>
    );
}
